import styled from 'styled-components'

export const MetricsGrid = styled.div<{
  $columns?: number | 'auto'
  $minColumnWidth?: string
  $showBorders?: boolean
}>`
  display: grid;
  grid-template-columns: ${({ $columns, $minColumnWidth }) =>
    $columns === 'auto'
      ? `repeat(auto-fit, minmax(${$minColumnWidth || '100px'}, 1fr))`
      : `repeat(${$columns || 3}, 1fr)`};
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.large} 0;
  ${({ $showBorders, theme }) =>
    $showBorders &&
    `
    border-top: 1px solid ${theme.colors.border.light};
    border-bottom: 1px solid ${theme.colors.border.light};
  `}
`

export const MetricItem = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
`

export const MetricIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.colors.background.tertiary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const MetricValue = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1;
`

export const MetricLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-transform: uppercase;
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
  margin-top: ${({ theme }) => theme.spacing.xsmall};
`
